import React, { useEffect, useState } from "react";
import { Box, Button, TextField, Typography } from "@mui/material";
import CustomTable from "../../components/table/Table";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { clearMessage } from "../../redux/Slice/message";
import { useDispatch, useSelector } from "react-redux";
import { getQuote, updateQuote } from "../../redux/Slice/quoteSlice";
import { setLoading } from "../../redux/Slice/loaderSlice";

const columns = [
  { id: "temp_id", label: "Template No", minWidth: 150, align: "start" },
  { id: "name", label: "Template Name", minWidth: 150, align: "start" },
  { id: "status", label: "Status", minWidth: 150, align: "center" },
  {
    id: "action",
    label: "Action",
    minWidth: 150,
    align: "center",
    actionType: [{ edit: true, view: true }],
  },
];

export const QuoteInactive = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [modifiedRows, setModifiedRows] = useState([]);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const message = useSelector((state) => state.message);
  const { quotes, totalPages } = useSelector((state) => state.quote);
  console.log("quotes:",quotes);

  const transformedQuotes = (quotes) => quotes
  .filter((quote) => quote && quote._id && quote.status === false)
  .map((quote) => ({
    _id: quote._id,
    temp_id: quote.quote_id,
    name: quote.templateName,
    status: quote.status ? true : false,
    action: "",
  }))

     useEffect(() => {
       if (Array.isArray(quotes)) {
         const transformedLeads = transformedQuotes(quotes);
         setModifiedRows(transformedLeads);
       }
     }, [quotes]);
    
  
    useEffect(() => {
      if (message?.message) {
        toast(message.message);
        dispatch(clearMessage());
      }
    }, [message, dispatch]);

 useEffect(() => {
     dispatch(setLoading(true));
     dispatch(getQuote({ page, limit: rowsPerPage, searchTerm }))
       .then(() => {
         dispatch(setLoading(false));
       })
       .catch(() => {
         dispatch(setLoading(false));
       });
   }, [dispatch, page, rowsPerPage, searchTerm]);
 
   const handleStatusChange = (row) => {
     const updatedStatus = !row.status;
     const quoteId = row._id;
 
     dispatch(setLoading(true));
     dispatch(updateQuote( { q_id: quoteId, formData: { status: updatedStatus }})).unwrap()
      .then(() => {
     
       // Update the modifiedRows locally
       const updatedRows = modifiedRows.filter((item) =>
         item._id !== quoteId || updatedStatus === false
       );
       setModifiedRows(updatedRows);
       })
       .catch((error) => {
         console.error("Failed to update status:", error);
         toast.error("Failed to update status. Please try again.");
       })
       .finally(() => {
         dispatch(setLoading(false));
       });
   }
 
   const handleSearch = (event) => {
     setSearchTerm(event.target.value);
   };
 
   const handleEdit = (row) => {
     if (row._id) {
       navigate(`/quote/edit/${row._id}`);
     } else {
       console.log("No lead ID found for this row", row);
     }
   };
 
   const handleView = (row) => {
     if(row._id) {
       navigate(`/quote/${row._id}`);
     } else {
       console.log("No Quote ID found for this row", row);
     }
   }
 
   return (
     <div className="content">
       <Box
         sx={{
           display: "flex",
           justifyContent: "space-between",
           alignItems: "center",
         }}
       >
         <Typography variant="h5" sx={{ mb: 3, mt: 3 }}>
           Quotation List 
           <Typography component="span">({modifiedRows.length})</Typography>
         </Typography>
         <Box
           sx={{
             display: "flex",
             alignItems: "center",
           }}>
           <TextField placeholder="Search by Name" value={searchTerm} onChange={handleSearch} fullWidth/>
 
           <Link to='/quote/add'>
           <Button
             variant="contained"
             color="success"
             sx={{ ml: 2, px: 3 ,
               "&:hover": { backgroundColor: "#2FB354" },}}
           >
             Add
           </Button>
           </Link>
         </Box>
       </Box>
 
       <CustomTable
         columns={columns}
         rows={modifiedRows}
         page={page}
         setPage={setPage}
         rowsPerPage={rowsPerPage}
         setRowsPerPage={setRowsPerPage}
         totalPages={totalPages}
         handleEdit={handleEdit}
         handleView={handleView}
         handleStatusChange={handleStatusChange}
       />
     </div>
   );
 };